module.exports = __webpack_public_path__ + "static/img/starx.6dd80a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/starx.png
// module id = pMul
// module chunks = 1